import styled from 'styled-components'

export const StBold = styled.span`
  font-weight: normal;
`
